import { GET_CASSETTES_SUCCESS } from "../actions/actionTypes";
import { Cassette } from "../models/cassette.interface";

interface CassetteState {
  cassettes: Cassette[];
}
const initialState: CassetteState = {
  cassettes: [],
};

const cassetteReducer = (
  state = initialState,
  action: { type: string; payload: any }
): CassetteState => {
  switch (action.type) {
    case GET_CASSETTES_SUCCESS: {
      return {
        ...state,
        cassettes: action.payload
      }
    }
    default:
      return state;
  }
};

export default cassetteReducer;
